/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isFalse, isObject, isStringNotEmpty, isTrue, objectHasPropertyString } from "utils/empty-exists";
import { cloneObjectsArray } from "utils/array";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { ComponentLinkListItemContext } from "./component-link-list-context";

const LinkListLink = () => {
    
    const { token } = useAuth();
    const {
        item,
        index,
        list,
        updateItems
    } = useContext(ComponentLinkListItemContext) || {};
    
    const { link: guid } = item || {};

    const [link, setLink] = useState();
    const [loadingLink, setLoadingLink] = useState(false);

    const loadLink = async () => {
        if (isStringNotEmpty(guid)) {
            setLoadingLink(true);
            const _link = await SimpliCityAdminSDK.link.findOne(token, item?.link);
            setLink(_link);
            setLoadingLink(false);
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isStringNotEmpty(guid)) {
                await loadLink(guid);
            } else {
                setLink(undefined);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);

    const onChangeLink = async (link) => {
        setLink(link);
        const updatedLinks = cloneObjectsArray(list);
        updatedLinks[index].link = link?.guid;
        updatedLinks[index].position = index;
        updateItems(updatedLinks);
    };
    const onRemoveLink = async () => {
        setLink(undefined);
        // setLinkGuid(undefined)
        const updatedLinks = cloneObjectsArray(list);
        updatedLinks[index].link = "";
        updateItems(updatedLinks);
    };

    return (
        <Fragment>
            
            {isTrue(loadingLink) &&
                <Fragment></Fragment>
            }
            
            {isFalse(loadingLink) &&
                <div style={{ flex: "1" }}>
                    <LinkSelectorWrapper
                        link={link}
                        setLink={setLink}
                        onLinkChange={(link) => onChangeLink(link)}
                        onLinkRemove={() => onRemoveLink()}
                        disabled={false}
                        loadingLink={loadingLink}
                        setLoadingLink={setLoadingLink}
                    />
                </div>
            }
            
        </Fragment>
    );
};
LinkListLink.displayName = "LinkListLink";
export { LinkListLink };
